/* ════════ app.js ════════ */
/* 99 Sheep — homepage behavior: sticky nav, donation counter, scroll reveal */
(function () {
  "use strict";

  // Sticky nav background after scroll, plus re-anchoring: the nav scrolls
  // away with the top of the page, then drops back in fixed once the reader
  // clears the scrollytelling hero and reaches the first classic section.
  // (body overflow-x:hidden defeats position:sticky, which is why the fixed
  // state is toggled here rather than left to CSS.)
  var nav = document.getElementById("nav");
  var hero = document.getElementById("scrolly-hero");
  var anchorY = Infinity;
  function measureAnchor() {
    // Publish the real nav height so the stylesheet can hold the layout
    // steady while the nav is out of the flow, whatever the theme sizes it to.
    document.documentElement.style.setProperty("--nav-h", nav.offsetHeight + "px");
    if (!hero) return;
    anchorY = hero.offsetTop + hero.offsetHeight - nav.offsetHeight;
  }
  measureAnchor();
  window.addEventListener("resize", measureAnchor, { passive: true });
  window.addEventListener("load", measureAnchor);
  // The hero has no height until its own bundle mounts, which happens after
  // load — measure once and the threshold lands at the top of the page and the
  // nav anchors immediately. Watching the element instead is exact whenever it
  // settles, and covers later reflows for free.
  if (hero && window.ResizeObserver) new ResizeObserver(measureAnchor).observe(hero);
  function onScroll() {
    if (window.scrollY > 24) nav.classList.add("scrolled");
    else nav.classList.remove("scrolled");
    var anchored = window.scrollY >= anchorY;
    nav.classList.toggle("anchored", anchored);
    // pad the body while the nav is out of the flow so nothing shifts
    document.documentElement.classList.toggle("nav-anchored", anchored);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // Reveal on scroll — visible by default; hide only below-the-fold items, with failsafe.
  // Where the browser can drive animation from scroll position, the stylesheet
  // does this instead, and does it better: the reveal stays tied to where the
  // element is rather than firing once and being done. The exception is a
  // reveal that is also a parallax layer — a CSS animation outranks the inline
  // transform this file writes each frame for parallax, and would freeze it —
  // so those stay here.
  var sda = !!(window.CSS && CSS.supports && CSS.supports("animation-timeline", "view()"));
  var reveals = [].slice.call(document.querySelectorAll(sda ? ".reveal[data-speed]" : ".reveal"));
  function show(el) { el.classList.remove("pending"); el.classList.add("in"); }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -6% 0px" });
    reveals.forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      if (top < window.innerHeight * 0.96) {
        show(el); // already on screen — reveal immediately, no hidden flash
      } else {
        el.classList.add("pending");
        io.observe(el);
      }
    });
    // failsafe: never leave anything hidden
    setTimeout(function () { reveals.forEach(show); }, 2600);
  } else {
    reveals.forEach(show);
  }

  // Animated donation counter
  var counter = document.getElementById("counter");
  function animateCounter() {
    var target = parseInt(counter.getAttribute("data-target"), 10) || 0;
    var dur = 1800, start = null;
    function fmt(n) {
      return "<span class='accent'>$</span>" + Math.floor(n).toLocaleString("en-US");
    }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      counter.innerHTML = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else counter.innerHTML = fmt(target);
    }
    requestAnimationFrame(step);
  }
  if (counter) {
    if ("IntersectionObserver" in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animateCounter(); cio.disconnect(); }
        });
      }, { threshold: 0.5 });
      cio.observe(counter);
    } else { animateCounter(); }
  }

  // Mobile menu (burger under 940px)
  var burger = document.getElementById("navBurger");
  var menu = document.getElementById("mobileMenu");
  if (burger && menu) {
    function setMenu(open) {
      menu.classList.toggle("open", open);
      menu.setAttribute("aria-hidden", String(!open));
      burger.setAttribute("aria-expanded", String(open));
      document.body.classList.toggle("menu-open", open);
    }
    burger.addEventListener("click", function () {
      setMenu(!menu.classList.contains("open"));
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { setMenu(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menu.classList.contains("open")) setMenu(false);
    });
  }
})();


/* ════════ enhance.js ════════ */
/* ============================================================
   99 SHEEP CO. — motion layer
   1) Lenis liquid smooth scroll
   2) scroll-velocity blur on heavy media
   3) mouse-trailing gold glow (velocity-stretched)
   4) horizontal-on-vertical: marquee + pinned gallery
   5) multi-speed parallax + masked heading reveals
   Pure vanilla + one CDN lib. Shopify-portable.
   ============================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var coarse = window.matchMedia("(pointer: coarse)").matches;

  /* ---------- 1 · LENIS LIQUID SCROLL ---------- */
  var lenis = null;
  if (!reduce && window.Lenis) {
    lenis = new Lenis({
      lerp: 0.085,            // lower = more glide ("liquid")
      wheelMultiplier: 1,
      smoothWheel: true,
      syncTouch: false
    });
    // keep anchor links working through Lenis
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href");
        if (id.length < 2) return;
        var t = document.querySelector(id);
        if (!t) return;
        e.preventDefault();
        lenis.scrollTo(t, { offset: -90, duration: 1.4 });
      });
    });
  }

  /* ---------- shared scroll state ---------- */
  var vh = window.innerHeight;
  var scrollY = window.scrollY || 0;
  var velocity = 0;            // px/frame, smoothed

  /* ---------- collect effect targets ---------- */
  var parallax = [].slice.call(document.querySelectorAll("[data-speed]"));
  var blurEls  = [].slice.call(document.querySelectorAll("[data-blur]"));
  var marquees = [].slice.call(document.querySelectorAll("[data-marquee]"));
  // The stylesheet slides the journey wherever scroll-driven animation is
  // available: it is tied to scroll position rather than chasing it a frame
  // late, and it runs on phones, where this driver was switched off outright.
  var sda = !!(window.CSS && CSS.supports && CSS.supports("animation-timeline", "view()"));
  var hsections = sda ? [] : [].slice.call(document.querySelectorAll("[data-hscroll]"));

  /* ---------- 5 · MASKED HEADING REVEALS ---------- */
  var masks = [].slice.call(document.querySelectorAll(".mask-rise"));
  if ("IntersectionObserver" in window && !reduce) {
    var mio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); mio.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    masks.forEach(function (m) { mio.observe(m); });
  } else {
    masks.forEach(function (m) { m.classList.add("in"); });
  }

  /* ---------- 2 · SCROLL-VELOCITY BLUR ---------- */
  function applyBlur() {
    // map smoothed velocity → 0..1, capped so it stays tasteful
    var v = Math.min(Math.abs(velocity) / 55, 1);
    for (var i = 0; i < blurEls.length; i++) {
      blurEls[i].style.setProperty("--v", v.toFixed(3));
    }
  }

  /* ---------- 5 · PARALLAX ----------
     Document-space centers are cached at load/resize so the RAF never calls
     getBoundingClientRect (which forces layout and feeds back the transform). */
  var plxCache = [];
  function measureParallax() {
    plxCache = parallax.map(function (el) {
      var prev = el.style.transform;
      el.style.transform = "";                       // measure untranslated
      var r = el.getBoundingClientRect();
      el.style.transform = prev;
      return {
        el: el,
        speed: parseFloat(el.getAttribute("data-speed")) || 0,
        center: r.top + (window.scrollY || 0) + r.height / 2
      };
    });
  }
  function applyParallax() {
    for (var i = 0; i < plxCache.length; i++) {
      var p = plxCache[i];
      var center = p.center - scrollY;
      var offset = (center - vh / 2) * p.speed * -0.12;
      p.el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
    }
  }

  /* ---------- 3 · HORIZONTAL MARQUEE (vertical-scroll driven) ---------- */
  function applyMarquee() {
    for (var i = 0; i < marquees.length; i++) {
      var track = marquees[i];
      var base = parseFloat(track.getAttribute("data-base") || "0.18");
      // half the track is a duplicate, so wrap at -50%
      var w = track.scrollWidth / 2;
      var x = (-scrollY * base) % w;
      track.style.transform = "translate3d(" + x.toFixed(1) + "px,0,0)";
    }
  }

  /* ---------- 4 · PINNED HORIZONTAL GALLERY (geometry cached) ---------- */
  var hsCache = [];
  function measureHScroll() {
    hsCache = hsections.map(function (wrap) {
      var track = wrap.querySelector(".hscroll-track");
      return {
        wrap: wrap,
        track: track,
        bar: wrap.querySelector(".hscroll-progress i"),
        top: wrap.getBoundingClientRect().top + (window.scrollY || 0),
        total: Math.max(wrap.offsetHeight - vh, 0),
        maxX: track ? Math.max(track.scrollWidth - window.innerWidth, 0) : 0
      };
    });
  }
  function applyHScroll() {
    for (var i = 0; i < hsCache.length; i++) {
      var h = hsCache[i];
      if (!h.track) continue;
      // progress through the tall wrapper: 0 when entering, 1 when leaving
      var p = h.total > 0 ? clamp((scrollY - h.top) / h.total, 0, 1) : 0;
      h.track.style.transform = "translate3d(" + (-p * h.maxX).toFixed(1) + "px,0,0)";
      if (h.bar) h.bar.style.width = (p * 100).toFixed(1) + "%";
    }
  }

  function clamp(n, a, b) { return n < a ? a : n > b ? b : n; }

  /* ---------- MAIN RAF ---------- */
  var lastY = scrollY;
  function frame(t) {
    if (lenis) lenis.raf(t);
    var y = lenis ? lenis.scroll : (window.scrollY || 0);
    var raw = y - lastY;
    velocity += (raw - velocity) * 0.25;   // smooth the velocity
    lastY = y;
    scrollY = y;

    applyParallax();
    applyMarquee();
    applyHScroll();
    applyBlur();
    updateTrail();

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  function remeasure() {
    vh = window.innerHeight;
    measureParallax();
    measureHScroll();
  }
  remeasure();
  window.addEventListener("resize", remeasure, { passive: true });
  window.addEventListener("load", remeasure);   // fonts/media can shift layout

  /* ---------- 3 · CURSOR LAMB ----------
     A little cartoon white lamb that trails the cursor with inertia. When the
     pointer moves it breaks into a walk (legs + ears in motion, body bobbing,
     facing its travel direction) and trots to catch up; when you stop, it
     ambles to a halt beside the cursor. */
  var LAMB_SVG =
    '<svg viewBox="0 0 124 98" fill="none">' +
      '<g class="body-grp">' +
        '<g class="legs" stroke="#fcfcf7" stroke-width="3" paint-order="stroke">' +  /* white rim so the legs read against a dark ground */
          '<rect class="leg leg-b" x="34" y="54" width="9" height="34" rx="4.5" fill="#33333b"/>' +
          '<rect class="leg leg-a" x="48" y="54" width="9" height="34" rx="4.5" fill="#33333b"/>' +
          '<rect class="leg leg-b" x="70" y="54" width="9" height="34" rx="4.5" fill="#33333b"/>' +
          '<rect class="leg leg-a" x="84" y="54" width="9" height="34" rx="4.5" fill="#33333b"/>' +
        '</g>' +
        '<g fill="#2b2b33">' +              /* dilated dark silhouette = clean outline */
          '<circle cx="20" cy="46" r="11"/>' +
          '<ellipse cx="56" cy="48" rx="42" ry="28"/>' +
          '<circle cx="28" cy="32" r="16"/>' +
          '<circle cx="46" cy="23" r="17"/>' +
          '<circle cx="66" cy="23" r="17"/>' +
          '<circle cx="85" cy="30" r="16"/>' +
          '<circle cx="30" cy="58" r="14"/>' +
          '<circle cx="80" cy="58" r="14"/>' +
          '<circle cx="100" cy="45" r="21"/>' +
          '<circle cx="90" cy="29" r="14"/>' +
        '</g>' +
        '<g fill="#fcfcf7">' +              /* white wool fill, 3px inside the dark */
          '<circle cx="20" cy="46" r="8"/>' +
          '<ellipse cx="56" cy="48" rx="39" ry="25"/>' +
          '<circle cx="28" cy="32" r="13"/>' +
          '<circle cx="46" cy="23" r="14"/>' +
          '<circle cx="66" cy="23" r="14"/>' +
          '<circle cx="85" cy="30" r="13"/>' +
          '<circle cx="30" cy="58" r="11"/>' +
          '<circle cx="80" cy="58" r="11"/>' +
          '<circle cx="100" cy="45" r="18"/>' +
          '<circle cx="90" cy="29" r="11"/>' +
        '</g>' +
        '<g class="ear">' +
          '<ellipse cx="88" cy="30" rx="6.5" ry="11" transform="rotate(-28 88 30)" fill="#2b2b33"/>' +
          '<ellipse cx="88" cy="31" rx="3" ry="6.5" transform="rotate(-28 88 31)" fill="#d39aa3"/>' +
        '</g>' +
        '<circle cx="106" cy="43" r="3.1" fill="#26262c"/>' +
        '<circle cx="107.1" cy="42" r="1" fill="#fff"/>' +
        '<ellipse cx="113" cy="51" rx="5.2" ry="4.2" fill="#d39aa3"/>' +
        '<circle cx="111.5" cy="51" r="0.9" fill="#7a4a52"/>' +
        '<circle cx="114.5" cy="51" r="0.9" fill="#7a4a52"/>' +
      '</g>' +
    '</svg>';

  var lamb = null;
  var cross = null;
  var mx = 0, my = 0, lx = 0, ly = 0, active = 0, want = 0, facing = 1;

  // Simple red Jerusalem cross — one cross potent + four crosslets, all rectangles
  var CROSS_SVG =
    '<svg viewBox="0 0 100 100" fill="currentColor" aria-hidden="true">' +
      '<rect x="45" y="22" width="10" height="56" rx="1"/>' +     /* vertical bar */
      '<rect x="22" y="45" width="56" height="10" rx="1"/>' +     /* horizontal bar */
      '<rect x="38" y="19" width="24" height="7" rx="1"/>' +      /* top cap */
      '<rect x="38" y="74" width="24" height="7" rx="1"/>' +      /* bottom cap */
      '<rect x="19" y="38" width="7" height="24" rx="1"/>' +      /* left cap */
      '<rect x="74" y="38" width="7" height="24" rx="1"/>' +      /* right cap */
      /* four crosslets in the quadrants */
      '<rect x="9.5" y="4" width="5" height="13" rx="1"/><rect x="5.5" y="8" width="13" height="5" rx="1"/>' +
      '<rect x="85.5" y="4" width="5" height="13" rx="1"/><rect x="81.5" y="8" width="13" height="5" rx="1"/>' +
      '<rect x="9.5" y="83" width="5" height="13" rx="1"/><rect x="5.5" y="87" width="13" height="5" rx="1"/>' +
      '<rect x="85.5" y="83" width="5" height="13" rx="1"/><rect x="81.5" y="87" width="13" height="5" rx="1"/>' +
    '</svg>';

  if (!reduce && !coarse) {
    lamb = document.createElement("div");
    lamb.className = "cursor-lamb";
    lamb.setAttribute("aria-hidden", "true");
    lamb.innerHTML = LAMB_SVG;
    document.body.appendChild(lamb);

    cross = document.createElement("div");
    cross.className = "cursor-cross";
    cross.setAttribute("aria-hidden", "true");
    cross.innerHTML = CROSS_SVG;
    document.body.appendChild(cross);

    lx = mx = window.innerWidth / 2; ly = my = window.innerHeight / 2;
    window.addEventListener("mousemove", function (e) { mx = e.clientX; my = e.clientY; want = 1; }, { passive: true });
    document.addEventListener("mouseenter", function () { want = 1; });
    window.addEventListener("mouseout", function (e) { if (!e.relatedTarget) want = 0; });
  } else if (!reduce && coarse && sda) {
    // No cursor to follow on a phone, so the same lamb walks the page instead.
    // Built from the one LAMB_SVG above, so he is the same animal, not a
    // drawing of him; the stylesheet ties his position, his stride and his
    // three jumps to how far down the page you have come.
    var walker = document.createElement("div");
    walker.className = "walk-lamb";
    walker.setAttribute("aria-hidden", "true");
    walker.innerHTML = LAMB_SVG;
    document.body.appendChild(walker);
  }
  function updateTrail() {
    if (!lamb) return;
    // v5: the three trails gate themselves — CSS no longer hides the inactive ones
    var mode = document.documentElement.getAttribute("data-cursor") || "sheep";
    active += (want - active) * 0.06;
    var dx = mx - lx, dy = my - ly;
    lx += dx * 0.085;                       // trails behind, eases in → "catches up"
    ly += dy * 0.085;
    var speed = Math.hypot(dx, dy);
    if (Math.abs(dx) > 1.2) facing = dx > 0 ? 1 : -1;
    var op = active.toFixed(3);

    if (mode === "sheep") {
      lamb.classList.toggle("walking", speed > 5 && active > 0.2);
      var px = lx - facing * 4, py = ly + 6;
      lamb.style.opacity = op;
      lamb.style.transform =
        "translate3d(" + px.toFixed(1) + "px," + py.toFixed(1) + "px,0)" +
        " translate(-50%,-80%) scaleX(" + facing + ")";
    } else {
      lamb.style.opacity = "0";
      lamb.classList.remove("walking");
    }

    if (cross) {
      if (mode === "cross") {
        // cross hangs just below/right of the cursor, upright, with a soft velocity lean
        var lean = Math.max(-10, Math.min(10, dx * 0.6));
        cross.style.opacity = op;
        cross.style.transform =
          "translate3d(" + (lx + 8).toFixed(1) + "px," + (ly + 10).toFixed(1) + "px,0)" +
          " translate(-50%,-50%) rotate(" + lean.toFixed(1) + "deg)";
      } else {
        cross.style.opacity = "0";
      }
    }
  }

  /* ---------- pointer-lean on cards ---------- */
  if (!reduce && !coarse) {
    document.querySelectorAll("[data-pointer-lean], .six-grid .card:not(.flipcard)").forEach(function (card) {
      var inner = card.querySelector(".ph") || card.querySelector("img");
      if (!inner) return;
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        inner.style.transform = "scale(1.06) translate(" + (dx * 14).toFixed(1) + "px," + (dy * 14).toFixed(1) + "px)";
      });
      card.addEventListener("mouseleave", function () { inner.style.transform = ""; });
    });
  }
})();


/* ════════ medal.js ════════ */
/* ============================================================
   99 SHEEP CO. — Medal watermark choreography
   The Miraculous Medal is the brand's still anchor: a fixed,
   almost-subliminal watermark behind every section. Per scroll
   position this driver blends the watermark between per-section
   "personalities" (opacity / scale / drift) so it brightens at
   the narrative beats — hero, mission, founder story, final CTA —
   and recedes everywhere else.
   Section tops are cached at load/resize; the RAF does no layout
   reads. Pure vanilla, writes CSS vars only.
   ============================================================ */
(function () {
  "use strict";

  var wm = document.getElementById("medalWM");
  if (!wm) return;

  /* per-section watermark personality */
  var SECTIONS = [
    /* opacity, scale, x%, y% */
    { sel: "#scrolly-hero",  op: 0.00, s: 1.00, x: 0,   y: 0  },   /* the scroll story has the stage */
    { sel: ".hero-film",     op: 0.00, s: 1.00, x: 0,   y: 0  },   /* ditto the older film hero, for themes still on it */
    { sel: ".hero",          op: 0.10, s: 1.00, x: 0,   y: 0  },
    { sel: ".creed",         op: 0.04, s: 0.95, x: 0,   y: -6 },
    { sel: ".beneficiaries", op: 0.16, s: 1.05, x: -14, y: 4  },
    { sel: ".hscroll",       op: 0.05, s: 0.92, x: 10,  y: -2 },
    { sel: ".six",           op: 0.05, s: 0.95, x: -8,  y: 0  },
    { sel: "#canvas",        op: 0.05, s: 0.95, x: 8,   y: 0  },
    { sel: ".offering",      op: 0.12, s: 1.02, x: 0,   y: 0  },
    { sel: ".story",         op: 0.20, s: 1.08, x: 18,  y: 2  },
    { sel: ".families",      op: 0.05, s: 0.95, x: -10, y: 4  },
    { sel: ".final",         op: 0.14, s: 1.00, x: 0,   y: 0  }
  ];

  var targets = [];
  SECTIONS.forEach(function (cfg) {
    var el = document.querySelector(cfg.sel);
    if (el) targets.push({ el: el, cfg: cfg, top: 0 });
  });
  if (!targets.length) return;

  function measure() {
    var sy = window.scrollY || 0;
    targets.forEach(function (t) {
      t.top = t.el.getBoundingClientRect().top + sy;
    });
  }
  measure();
  window.addEventListener("resize", measure, { passive: true });
  window.addEventListener("load", measure);
  // Every section below the hero sits 3000-odd pixels lower once the hero's
  // own bundle mounts, which happens after load — so a single measurement has
  // the whole page in the wrong place and the watermark's choreography runs
  // early. measure() only reads layout, so observing the page is safe.
  if (window.ResizeObserver) new ResizeObserver(measure).observe(document.body);

  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(n, a, b) { return n < a ? a : n > b ? b : n; }

  /* Which two adjacent sections are we between, and how far across?
     The watermark interpolates smoothly between their personalities. */
  function currentBlend() {
    var mid = (window.scrollY || 0) + window.innerHeight * 0.45;
    var idx = 0;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].top <= mid) idx = i;
    }
    var a = targets[idx];
    var b = targets[Math.min(idx + 1, targets.length - 1)];
    var span = (b.top - a.top) || 1;
    var t = clamp((mid - a.top) / span, 0, 1);
    return { a: a, b: b, t: t };
  }

  /* low-pass smoothed state — meditative, never twitchy */
  var smoothOp = 0.05, smoothS = 1, smoothX = 0, smoothY = 0;

  function frame() {
    var c = currentBlend();
    var op = lerp(c.a.cfg.op, c.b.cfg.op, c.t);
    var s  = lerp(c.a.cfg.s,  c.b.cfg.s,  c.t);
    var x  = lerp(c.a.cfg.x,  c.b.cfg.x,  c.t);   /* in %vw */
    var y  = lerp(c.a.cfg.y,  c.b.cfg.y,  c.t);   /* in %vh */

    smoothOp += (op - smoothOp) * 0.06;
    smoothS  += (s  - smoothS)  * 0.06;
    smoothX  += (x  - smoothX)  * 0.05;
    smoothY  += (y  - smoothY)  * 0.05;

    wm.style.setProperty("--mw-op", smoothOp.toFixed(3));
    wm.style.setProperty("--mw-s",  smoothS.toFixed(3));
    wm.style.setProperty("--mw-x",  (smoothX * window.innerWidth  / 100).toFixed(1) + "px");
    wm.style.setProperty("--mw-y",  (smoothY * window.innerHeight / 100).toFixed(1) + "px");

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();


/* ════════ film.js ════════ */
/* ============================================================
   99 SHEEP CO. — hero film driver
   1) End-of-loop ritual: over the last second the film fades out
      and the gold 99 Sheep seal fades in (.film-ending). The seal
      then HOLDS alone for a beat before the film fades back in and
      the loop resumes — a punctuation mark, not a transition.
   2) Scroll exposure ramp: sets --film-dim (0..1) as the hero
      slides up over the film, so the film settles into black
      instead of scrolling away at full brightness.
   3) Graceful degradation: if no film source is set — or a codec
      stalls silently (readyState stays 0 with no error event) —
      the whole 170vh section collapses.
   4) Battery/CPU: pauses when scrolled out of view.
   Vanilla, one RAF.
   ============================================================ */
(function () {
  "use strict";

  var section = document.querySelector(".hero-film");
  var sticky = document.getElementById("filmSticky");
  var film = document.getElementById("heroFilm");
  if (!section || !sticky || !film) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var FADE = 1.0;     // s before loop end that the seal crossfade starts
  var HOLD = 700;     // ms the seal holds alone before the film returns

  /* ---- graceful hide when the film is missing or won't play ---- */
  function hideSection() { section.style.display = "none"; }
  film.addEventListener("error", hideSection, true); // capture <source> errors
  var lastSource = film.querySelector("source:last-of-type");
  if (lastSource) lastSource.addEventListener("error", hideSection);
  if (!film.currentSrc && !film.querySelector("source")) hideSection();
  setTimeout(function () {
    if (film.readyState < 2) hideSection();   // HAVE_CURRENT_DATA not reached
  }, 4000);

  /* respect reduced motion: hold the first frame, no autoplay */
  if (reduce) { film.removeAttribute("autoplay"); film.pause(); }

  /* ---- section geometry (cached — no layout reads in the RAF) ---- */
  var secTop = 0, secRange = 1;
  function measure() {
    var r = section.getBoundingClientRect();
    secTop = r.top + (window.scrollY || 0);
    secRange = Math.max(section.offsetHeight - window.innerHeight, 1);
  }
  measure();
  window.addEventListener("resize", measure, { passive: true });

  /* ---- visibility: pause off-screen (but never mid-hold) ---- */
  var inView = true, holding = false;
  if ("IntersectionObserver" in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        inView = e.isIntersecting;
        if (inView && !holding) film.play().catch(function () {});
        if (!inView) film.pause();
      });
    }, { threshold: 0.05 });
    io.observe(section);
  }

  /* ---- main loop: crossfade timing + exposure ramp ---- */
  function frame() {
    /* exposure ramp from scroll progress through the 170vh zone */
    var p = ((window.scrollY || 0) - secTop) / secRange;
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    sticky.style.setProperty("--film-dim", p.toFixed(3));

    /* loop-end choreography */
    var d = film.duration;
    if (!holding && !reduce && d && isFinite(d)) {
      var t = film.currentTime;
      if (d - t <= FADE) {
        sticky.classList.add("film-ending");
      } else if (t < FADE && sticky.classList.contains("film-ending")) {
        /* the loop just restarted behind the seal: freeze the first frame
           and let the seal hold the stage before the film fades back */
        holding = true;
        film.pause();
        setTimeout(function () {
          sticky.classList.remove("film-ending");
          holding = false;
          if (inView && !reduce) film.play().catch(function () {});
        }, HOLD);
      }
    }

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();


/* ════════ thurible.js ════════ */
/* ============================================================
   99 SHEEP CO. — thurible cursor
   A small gold censer hangs from a chain below the cursor and
   swings with pendulum physics as the pointer moves. Incense
   smoke rises from the vents on a separate low-alpha canvas
   (the CSS blur on .cursor-smoke turns the particles into haze).
   Active only while <html data-cursor="thurible">; the lamb and
   cross trails in enhance.js gate themselves the same way.
   Vanilla, one RAF shared for physics + smoke.
   ============================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var coarse = window.matchMedia("(pointer: coarse)").matches;
  if (reduce || coarse) return;

  var CHAIN = 74;          // px from anchor (cursor) to censer body
  var GRAVITY = 34;        // pendulum restoring force
  var DAMP = 0.965;        // angular velocity damping

  /* ---- DOM: overlay + censer svg ---- */
  var wrap = document.createElement("div");
  wrap.className = "cursor-thurible";
  wrap.setAttribute("aria-hidden", "true");
  wrap.innerHTML =
    '<svg width="220" height="220" viewBox="-110 -110 220 220" style="position:absolute;left:0;top:0;overflow:visible">' +
      '<line class="th-chain" x1="0" y1="0" x2="0" y2="' + CHAIN + '" stroke="oklch(0.72 0.08 80)" stroke-width="1.4" stroke-dasharray="3.5 3" />' +
      '<g class="th-body">' +
        '<ellipse cx="0" cy="0" rx="12" ry="10" fill="oklch(0.66 0.10 78)" />' +          /* bowl */
        '<ellipse cx="0" cy="-7.5" rx="9" ry="4" fill="oklch(0.78 0.10 82)" />' +          /* lid */
        '<circle cx="0" cy="-12" r="2.2" fill="oklch(0.85 0.10 84)" />' +                  /* finial */
        '<circle cx="-5" cy="-2" r="1.3" fill="oklch(0.30 0.04 70)" />' +                  /* vents */
        '<circle cx="0"  cy="-1" r="1.3" fill="oklch(0.30 0.04 70)" />' +
        '<circle cx="5"  cy="-2" r="1.3" fill="oklch(0.30 0.04 70)" />' +
        '<circle cx="0" cy="2" r="3.4" fill="oklch(0.86 0.14 74 / 0.85)">' +               /* ember glow */
          '<animate attributeName="opacity" values="0.55;1;0.55" dur="2.2s" repeatCount="indefinite" />' +
        '</circle>' +
      '</g>' +
    '</svg>';
  document.body.appendChild(wrap);
  var svg = wrap.firstChild;
  var chainEl = svg.querySelector(".th-chain");
  var bodyEl = svg.querySelector(".th-body");

  /* ---- smoke canvas ---- */
  var canvas = document.createElement("canvas");
  canvas.className = "cursor-smoke";
  canvas.setAttribute("aria-hidden", "true");
  document.body.appendChild(canvas);
  var ctx = canvas.getContext("2d");
  function sizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  sizeCanvas();
  window.addEventListener("resize", sizeCanvas, { passive: true });

  /* ---- state ---- */
  var mx = window.innerWidth / 2, my = window.innerHeight / 2;   // cursor
  var ax = mx, ay = my;                                          // eased anchor
  var theta = 0, omega = 0;                                      // pendulum angle/velocity
  var lastAx = ax;
  var seen = false;
  var particles = [];

  window.addEventListener("mousemove", function (e) {
    mx = e.clientX; my = e.clientY;
    if (!seen) { seen = true; ax = mx; ay = my; lastAx = ax; }
  }, { passive: true });
  window.addEventListener("mouseout", function (e) { if (!e.relatedTarget) seen = false; });

  function active() {
    return document.documentElement.getAttribute("data-cursor") === "thurible" && seen;
  }

  function spawnSmoke(x, y) {
    if (particles.length > 90) return;
    particles.push({
      x: x + (Math.random() - 0.5) * 6,
      y: y - 4,
      vx: (Math.random() - 0.5) * 0.35,
      vy: -(0.5 + Math.random() * 0.5),
      r: 4 + Math.random() * 5,
      life: 1
    });
  }

  var lastT = performance.now();
  function frame(t) {
    var dt = Math.min((t - lastT) / 1000, 0.05);
    lastT = t;

    var on = active();
    wrap.classList.toggle("on", on);
    canvas.style.opacity = on ? "" : "0";

    if (on) {
      /* anchor eases toward the cursor (the hand holding the chain) */
      ax += (mx - ax) * 0.16;
      ay += (my - ay) * 0.16;

      /* pendulum: horizontal anchor acceleration swings the censer */
      var drive = (ax - lastAx) / Math.max(dt, 0.001);
      lastAx = ax;
      var accel = -GRAVITY * Math.sin(theta) - (drive / CHAIN) * 0.045;
      omega = (omega + accel * dt) * DAMP;
      theta += omega * dt;
      theta = Math.max(-1.1, Math.min(1.1, theta));

      var bx = ax + Math.sin(theta) * CHAIN;
      var by = ay + Math.cos(theta) * CHAIN;

      svg.style.transform = "translate(" + ax.toFixed(1) + "px," + ay.toFixed(1) + "px)";
      chainEl.setAttribute("x2", (Math.sin(theta) * CHAIN).toFixed(1));
      chainEl.setAttribute("y2", (Math.cos(theta) * CHAIN).toFixed(1));
      bodyEl.setAttribute("transform",
        "translate(" + (Math.sin(theta) * CHAIN).toFixed(1) + "," + (Math.cos(theta) * CHAIN).toFixed(1) +
        ") rotate(" + (-theta * 57.3 * 0.5).toFixed(1) + ")");

      /* smoke rises faster when the censer is swinging hard */
      if (Math.random() < 0.5 + Math.min(Math.abs(omega), 1.4) * 0.3) spawnSmoke(bx, by);
    }

    /* smoke always winds down even when the trail is switched off */
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.life -= dt * 0.42;
      if (p.life <= 0) { particles.splice(i, 1); continue; }
      p.x += p.vx + Math.sin(t / 900 + p.y * 0.02) * 0.18;
      p.y += p.vy;
      p.r += dt * 7;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = "rgba(235, 230, 220, " + (0.05 * p.life).toFixed(3) + ")";
      ctx.fill();
    }

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
